<template>
    <div v-if="langluageType != 'en'" class="zixun">
      <!-- <div class="item item1">
          <img src="../assets/image/icon-phone.png" alt="">
          <span>热线</span>
          <div class="msg phone ">010-86460766-861</div>
      </div>
      <div class="line"></div> -->
      <div class="item item1">
          <img src="../assets/image/icon-qy.png" alt="">
          <span>客服</span>
          <div class="msg img-kf"><img src="../assets/image/newCode.png" alt=""></div>
      </div>
</div>
<div v-else class="zixun" style="width: 50px;border-radius: 25px;">
      <!-- <div class="item item1">
          <img src="../assets/image/icon-phone.png" alt="">
          <span style="font-size: 9px;">HOTLINE</span>
          <div class="msg phone " style="right:70px">010-86460766-861</div>
      </div>
      <div class="line"></div> -->
      <div class="item item1">
          <img src="../assets/image/icon-qy.png" alt="">
          <span style="font-size: 9px;">SERVICE</span>
          <div class="msg img-kf" style="right:65px"><img src="../assets/image/newCode.png" alt=""></div>
      </div>
</div>
</template>
<script>
export default {
    data() {
      return {
        langluageType:sessionStorage.getItem('langluageType')||'ch'
      }
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/contact.vue